import React from 'react';
import { css } from '@compiled/react';
import { Text } from '@atlassian/learning-components';
import { token } from '@atlaskit/tokens';
import { media } from '@atlaskit/primitives/responsive';

import { getAssetUrl } from 'src/services/http/user';
import { Resource } from 'src/graphql/generated/graphql';

import SectionHeading from './SectionHeading';
import AnimatedLink from './AnimatedLink';

const ResourceSection: React.FC<{
  resource: Resource;
}> = ({ resource }) => {
  const title = resource.titleExternal;
  const description = resource.description;
  const link = resource.link;
  const linkText = resource.ctaText;

  return (
    <div
      css={containerStyles}
      style={
        { '--background-image': `url(${getAssetUrl('/images/hubs/rovoHubResourceBackground.svg')})` } as Record<
          string,
          string
        >
      }
    >
      <SectionHeading heading={title} />
      <div css={descriptionStyles}>
        <Text size="large">{description}</Text>
      </div>
      <AnimatedLink link={link} label={linkText} />
    </div>
  );
};

const containerStyles = css({
  backgroundImage: 'var(--background-image)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: token('space.200'),
  minHeight: '401px',
  maxWidth: '737px',
  padding: '0 90px',
  textAlign: 'center',
  margin: '0 auto',

  [media.below.sm]: {
    padding: `0 ${token('space.400')}`,
  },
});

const descriptionStyles = css({
  maxWidth: '556px',
});

export default ResourceSection;
